import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import CardAnnotation from './pages/CardAnnotation';
import AnnotationDetail from './pages/AnnotationDetail';
import DatasetManagement from './pages/DatasetManagement';
import CreateDataset from './pages/DatasetManagement/CreateDataset';
import AddData from './pages/DatasetManagement/AddData';
import DatasetDetail from './pages/DatasetManagement/DatasetDetail';
import CardNotFound from './pages/CardNotFound';
import DataLoadError from './pages/DataLoadError';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/card-annotation" replace />} />
        <Route path="/card-annotation" element={
          <MainLayout>
            <CardAnnotation />
          </MainLayout>
        } />
        <Route path="/annotation-detail/:id" element={
          <MainLayout>
            <AnnotationDetail />
          </MainLayout>
        } />
        {/* 独立的标注详情页面，无导航 */}
        <Route path="/annotation-detail-standalone/:id" element={<AnnotationDetail />} />
        <Route path="/card-not-found" element={
          <MainLayout>
            <CardNotFound />
          </MainLayout>
        } />
        <Route path="/data-load-error" element={
          <MainLayout>
            <DataLoadError />
          </MainLayout>
        } />
        <Route path="/dataset-management" element={
          <MainLayout>
            <DatasetManagement />
          </MainLayout>
        } />
        <Route path="/dataset-management/create" element={
          <MainLayout>
            {(collapsed) => <CreateDataset collapsed={collapsed} />}
          </MainLayout>
        } />
        <Route path="/dataset-management/add-data/:datasetId" element={
          <MainLayout>
            {(collapsed) => <AddData collapsed={collapsed} />}
          </MainLayout>
        } />
        <Route path="/dataset-management/detail/:datasetId" element={
          <MainLayout>
            {(collapsed) => <DatasetDetail collapsed={collapsed} />}
          </MainLayout>
        } />
      </Routes>
    </Router>
  );
};

export default App;